/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminBillEnumItem
 */
export interface AdminBillEnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof AdminBillEnumItem
     */
    code?: number;
    /**
     * 枚举标识名
     * @type {string}
     * @memberof AdminBillEnumItem
     */
    enumName?: string;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof AdminBillEnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the AdminBillEnumItem interface.
 */
export function instanceOfAdminBillEnumItem(value: object): value is AdminBillEnumItem {
    return true;
}

export function AdminBillEnumItemFromJSON(json: any): AdminBillEnumItem {
    return AdminBillEnumItemFromJSONTyped(json, false);
}

export function AdminBillEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminBillEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'enumName': json['enumName'] == null ? undefined : json['enumName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AdminBillEnumItemToJSON(json: any): AdminBillEnumItem {
    return AdminBillEnumItemToJSONTyped(json, false);
}

export function AdminBillEnumItemToJSONTyped(value?: AdminBillEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'enumName': value['enumName'],
        'name': value['name'],
    };
}

